<div class="header-fixed menubar-pin parent-container">
    <div id="base">
        <div id="content" class="pending-fees-report-main-container">
            <div class="page-name-heading-with-export-button">
                <div class="page-name-attendance">
                    <span class="report-text">{{ 'report' | translate }}</span>
                    <span class="attendance-heading"> {{ 'pendingFeesHeading'| translate }}</span>
                    <div class="academic-dropdown-year">
                        <span class="report-text-category">{{ 'chooseAcademicYearLabel' | translate }} </span>
                        <select class="academic-year-dropdown" id="academicYearSelect" [(ngModel)]="selectedYearId"
                            (change)="onSelectionChange()">
                            <option *ngFor="let year of academicYears" [value]="year.pkAcademicId">
                                {{ year.Year }}
                                <span *ngIf="year.isCurrentAcademic">
                                    {{'currentYearText' |  translate}}
                                </span>
                            </option>
                        </select>
                    </div>
                </div>
                <div>
                    <button
                        *ngIf="(pendingFeeData && pendingFeeData.length > 0)||(tableHeaderData && tableHeaderData.length>0 && tableBodyData && tableBodyData.length>0)"
                        (click)="exportReport()" class="btn-export-pending-fees-report" [disabled]="isExportingReport">
                        <i class="ri-download-2-line" *ngIf="!isExportingReport"></i>
                        <app-button-loader *ngIf="isExportingReport"></app-button-loader>
                        {{ 'export' | translate }}
                    </button>
                </div>
            </div>
            <div (click)="closeCollapseOptionTable()" class="filter-container-attendance" [ngClass]="{
          'filter-container-attendance': !isFilterExpanded,
          'filter-container-attendance-open': isFilterExpanded
        }">
                <div (click)="closeStudentSelection()" class="filter-data-attendance">
                    <div class="filters-names-attendance">
                        <div class="filter-text">{{ 'filter' | translate }} : </div>
                        <div class="applied-filters">
                            <span class="filter-name-text">{{ 'wing' | translate }} :</span><span>{{ appliedWing }}</span>
                        </div>
                        <div class="applied-filters">
                            <span class="filter-name-text">{{ 'class' | translate }} :</span><span>{{ appliedClass }}</span>
                        </div>
                        <div class="applied-filters">
                            <span class="filter-name-text">{{ 'section' | translate }} :</span><span>{{ appliedSection }}</span>
                        </div>
                        <div class="applied-filters">
                            <span class="filter-name-text">{{ 'gender' |  translate }} :</span><span>{{ appliedGender }}</span>
                        </div>
                        <div *ngIf="(appliedStudent !== '' && isSelectedStudentCountDisplay)"
                            class="applied-filters">
                            <span class="filter-name-text">{{ 'selectedStudent' | translate }} :</span><span>{{ appliedStudent
                                }}</span>
                        </div>
                    </div>
                    <div class="apply-and-reset-filter">
                        <div *ngIf="enableReset || enableBackButton" (click)="resetAllFilter()" class="reset-button">
                            {{ enableBackButton ? ('back' | translate) : ('Reset' | translate)}}
                        </div>
                        <div *ngIf="!isFilterExpanded" class="more-filter-button">
                            <button (click)="expandAllFilterItems()" >
                                {{ 'moreFilter'|translate }}
                            </button>
                        </div>
                        <div *ngIf="isFilterExpanded" class="less-filter-button">
                            <button (click)="expandAllFilterItems()">
                                {{ 'lessFilter' | translate }}
                            </button>
                        </div>
                    </div>
                </div>
                <div [ngClass]="{
            'selection-option': !isFilterExpanded,
            'selection-option-active': isFilterExpanded
          }">
                    <div *ngIf="!enableBackButton" class="main-container-selection" (click)="closeStudentSelection()">
                        <label class="select-box-label">{{ 'selectWing' | translate  }}</label>
                        <select [(ngModel)]="selectedWing" (change)="
                selectedWing
                  ? getClassCategoryData(selectedWing)
                  : applyAllWing()
              " class="selection-input" [disabled]="loadingWingData == true">
                            <option selected [ngValue]="null">{{'all' | translate }}</option>
                            <option *ngFor="let key of wingListData" [ngValue]="key">
                                {{ key.classCategoryName }}
                            </option>
                        </select>
                        <span *ngIf="loadingWingData" class="loader-for-selection">
                            <app-button-loader [borderStyle]="'3px solid var(--brand-primary-color)'"></app-button-loader></span>
                    </div>
                    <div *ngIf="!enableBackButton" class="main-container-selection" (click)="closeStudentSelection()">
                        <label class="select-box-label">{{ 'selectClass' | translate  }}</label>
                        <select [(ngModel)]="selectedClass" [disabled]="loadingClassData == true" (change)="
                selectedClass
                  ? getClassSectionData(selectedClass)
                  : applyAllClass()
              " class="selection-input">
                            <option value="" [ngValue]="null">{{'all' | translate }}</option>
                            <ng-container *ngFor="let key of classStandardData">
                                <option [ngValue]="key">
                                    {{ key.classStandardName }}
                                </option>
                            </ng-container>
                        </select>
                        <span *ngIf="loadingClassData" class="loader-for-selection">
                            <app-button-loader [borderStyle]="'3px solid var(--brand-primary-color)'"></app-button-loader></span>
                    </div>
                    <div *ngIf="!enableBackButton" class="main-container-selection" (click)="closeStudentSelection()">
                        <label class="select-box-label">{{ 'selectSection' | translate  }}</label>
                        <select [(ngModel)]="selectedSection" (change)="
                selectedSection
                  ? getStudentData(selectedSection)
                  : applyAllSection()
              " class="selection-input" [disabled]="loadingSectionData == true">
                            <option value="" [ngValue]="null">{{'all' | translate }}</option>
                            <ng-container *ngFor="let key of classSectionData">
                                <option [ngValue]="key">
                                    {{ key.classDivision }}
                                </option>
                            </ng-container>
                        </select>
                        <span *ngIf="loadingSectionData" class="loader-for-selection">
                            <app-button-loader [borderStyle]="'3px solid var(--brand-primary-color)'"></app-button-loader></span>
                    </div>
                    <div class="main-container-selection" (click)="closeStudentSelection()">
                        <label class="select-box-label">{{ 'selectGender' | translate  }}</label>
                        <select [(ngModel)]="selectedGender" (change)="
                selectedGender ? callClassStudentListData() : applyAllGender()
              " class="selection-input">
                            <option value="" [ngValue]="null" selected>{{'all' | translate }}</option>
                            <option *ngFor="let key of genderData" [ngValue]="key">
                                {{ key.studentGender }}
                            </option>
                        </select>
                    </div>
                    <div class="main-container-selection" *ngIf="completeStudentList && completeStudentList.length > 0">
                        <label class="select-box-label">{{ 'searchStudentLabel' | translate  }}</label>
                        <input class="search-input-box" type="text" placeholder="{{'searchStuduentPlaceholder' | translate }}"
                            (focus)="onFocusSearchInput()" (blur)="onBlurSearchInput()" (input)="onSearchChange($event.target.value)"
                            (click)="$event.stopPropagation()"
                            [value]="!isFocused && selectedStudentListLength != ''  ? selectedStudentListLength + ('selectedStudentText' | translate ) : ''" />
                        <div *ngIf="isOpenStudentSelection" class="student-dropdown-list"
                            (click)="$event.stopPropagation()">
                            <div class="name-container-dropdowns">
                                    <input id="all" #allCheckbox [checked]="allStudentSelected"
                                        class="select-student-checkbox" type="checkbox" (click)="markAllStudent(allCheckbox)" />
                                    <label for="all">{{'all' | translate }}</label>
                            </div>
                            <div *ngFor="let names of studentList; let i = index">
                                <div (click)="markStudent(i, $event)" class="name-container-dropdowns">
                                    <input [id]="'select-student-from-dropdown' + i" [checked]="names.isChecked == true"
                                        class="select-student-checkbox" type="checkbox" />
                                    <label>{{ names.studentName }}</label>
                                </div>
                            </div>
                        </div>

                        <div *ngIf="loadingStudentDropdownData == true" class="search-box-loader">
                            <app-button-loader [borderStyle]="'3px solid var(--brand-primary-color)'"></app-button-loader>
                        </div>
                    </div>
                </div>
                <div (click)="closeStudentSelection()" [ngClass]="{
            'apply-result-and-data-length': isFilterExpanded,
            'apply-result-and-data-length-disabled': !isFilterExpanded
          }">
                    <div class="result-length">
                        {{ resultAvailable }} {{ 'resultAvailable' | translate  }}
                    </div>
                    <div class="apply-filter-button">
                        <button (click)="applyFilter()">{{ 'applyFilter' | translate  }}</button>
                    </div>
                </div>
            </div>
            <div (click)="closeCollapseOptionTable()" class="student-stats-container-main">
                <ng-container *ngIf="!loadingStatData">
                    <div *ngFor="let key of studentStatData" class="total-student-count">
                        <div class="heading-stat">
                            {{ key.statKey }}
                        </div>
                        <div class="number-of-student" [title]='generateText(key.statValue)'>
                            {{schoolCurrencySymbol}}{{ formatNumber(key.statValue) }}
                        </div>
                    </div>
                </ng-container>
                <div *ngIf="loadingStatData" class="loader-data">
                    <app-button-loader [borderStyle]="'3px solid var(--brand-primary-color)'"></app-button-loader>
                </div>
            </div>

            <div [ngClass]="{
          'class-wise-data': !loadingClassTileData,
          'class-wise-data-loading': loadingClassTileData
        }">
                <ng-container *ngIf="!loadingClassTileData">
                    <div *ngFor="let key of pendingFeeData" class="class-attendance-stats"
                        (click)="fetchSelectedClassData(key)">
                        <div class="header-class-stats">
                            <div class="class-name">
                                {{ key.classStandard }} - {{ key.classDivision }}
                            </div>
                        </div>
                        <div class="data-stats-student">
                            <div class="collected-fee">
                                <div class="present-icon"></div>
                                <div>
                                    <div class="collected-fee-label">
                                        {{ 'feeCollected' | translate  }}
                                    </div>
                                    <div class="collected-fee-value" [title]='generateText(key.feeCollected)'>
                                        {{schoolCurrencySymbol}}{{  formatNumber(key.feeCollected) }}
                                    </div>
                                </div>
                            </div>
                            <div class="pending-fee">
                                <div class="absent-icon"></div>
                                <div>
                                    <div class="collected-fee-label">
                                        {{ 'feePending' | translate  }}
                                    </div>
                                    <div class="collected-fee-value" [title]='generateText(key.feePending)'>
                                        {{schoolCurrencySymbol}}{{ formatNumber(key.feePending) }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>

                <div *ngIf="loadingClassTileData" class="loader-data">
                    <app-button-loader [borderStyle]="'3px solid var(--brand-primary-color)'"></app-button-loader>
                </div>
            </div>
            <div class="table-of-student" *ngIf="tableHeaderData.length > 0">
                <table *ngIf="!loadingClassTableData" class class="table-data-category-wise">
                    <thead class="pending-fee-report-table-header">
                        <tr>
                            <ng-container *ngFor="let itemData of tableHeaderData; let i = index">
                                <th *ngIf="itemData.isDefault === 1" (click)="openTableHeadersOption(i)">
                                    <div class="table-header-th">
                                        <div class="column-name">{{ itemData.columnName }}</div>
                                        <div class="option-opener">
                                            <img class="row-dropdown-category" src="../../assets/img/row-dropdown.png"
                                                alt="arrow" />
                                        </div>
                                        <ng-container>
                                            <div *ngIf="optionHeaderIndex === i" class="options-in-header">
                                                <ng-container *ngFor="let item of tableHeaderData">
                                                    <div (click)="
                              !item.isDefault &&
                                updateTableColumn(itemData.slug, item.slug)
                            " class="option-value-data">
                                                        <input id="input-box-{{ item.slug }}" [checked]="item.isDefault"
                                                            [disabled]="item.isDefault" class="checkbox-selection-table"
                                                            type="checkbox" />
                                                        <label [ngClass]="{
                                'table-extra-column': item.isDefault === 1,
                                'table-extra-column-active':
                                  item.isDefault !== 1
                              }" for="input-box-{{ item.slug }}">
                                                            {{ item.columnName }}
                                                        </label>
                                                    </div>
                                                </ng-container>
                                            </div>
                                        </ng-container>
                                    </div>
                                </th>
                            </ng-container>
                        </tr>
                    </thead>
                    <tbody class="pending-fee-report-table-body" (click)="closeCollapseOptionTable()">
                        <ng-container *ngIf="tableBodyData && tableBodyData.length > 0">
                            <ng-container *ngFor="let tableInfo of tableBodyData">
                                <tr>
                                    <ng-container *ngFor="let tableColumns of tableHeaderData">
                                        <td *ngIf="tableColumns.isDefault === 1">
                                            <span>
                                                {{ tableInfo[tableColumns.columnName] }}
                                            </span>
                                        </td>
                                    </ng-container>
                                </tr>
                            </ng-container>
                        </ng-container>
                        <div *ngIf="tableBodyData.length == 0" class="no-data-available">
                            <img class="no-data-icon" src="../../assets/img/ no_data_available.png" alt="" />
                            <div class="no-data-message">
                                <div class="main-heading-no-data">{{'dataNotAvailable' | translate }}</div>
                                <div class="sub-heading-no-data">
                                    {{'dataNotAvailableSecond' | translate }}
                                </div>
                            </div>
                        </div>
                    </tbody>
                </table>
            </div>
            <div *ngIf="loadingClassTableData" class="loader-data-table">
                <app-button-loader [borderStyle]="'3px solid var(--brand-primary-color)'"></app-button-loader>
            </div>
            <div (click)="closeCollapseOptionTable()" class="page-switcher-container">
                <div class="select-number-of-page">
                    <span *ngIf="tableBodyData && tableBodyData.length > 0">{{
                        'showResult' | translate 
                        }}</span>
                    <select *ngIf="tableBodyData && tableBodyData.length > 0" class="page-limit-for-class-data-limit"
                        (change)="changePageLimit($event.target.value)">
                        <option value="10">10</option>
                        <option value="20">20</option>
                    </select>
                </div>
                <div class="page-number-container">
                    <div class="icon-for-page-switch" *ngIf="startingPageNumber > 1"
                        (click)="changePageLimitData(startingPageNumber - 1)">
                        <i class="ri-arrow-left-s-line"></i>
                    </div>
                    <ng-container *ngFor="let item of pageNumbers">
                        <div (click)="switchPageNumber(item)" [ngClass]="{
                'icon-for-page-switch-selected': item == startingPageNumber,
                'icon-for-page-switch': item != startingPageNumber,
                'icon-for-page-switch-disabled': item === '...'
              }">
                            {{ item }}
                        </div>
                    </ng-container>

                    <div class="icon-for-page-switch" (click)="changePageLimitData(startingPageNumber + 1)"
                        *ngIf="startingPageNumber != maxPageNumber">
                        <i class="ri-arrow-right-s-line"></i>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>